module.exports = __webpack_public_path__ + "images/no-image---16cdf5b56224f541ccf7795a3c5b0dc5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/product/search-simple/img/no-image.gif
// module id = 386
// module chunks = 0